import _ from 'lodash'
import React from 'react'

export const WebLoader = () =>
  !_.get(window, ['__FT__APP__STATE', 'project', 'Settings', 'ui', 'isHideSkeleton'], false) && (
    <div className="ft-web-loading-animation">
      <span />
    </div>
  )

export const SuspenseLoader = ({ children }) => <React.Suspense fallback={<WebLoader />}>{children}</React.Suspense>

export default WebLoader
